import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkProcessorDetails {
  static fromProto(proto) {
    let m = new BulkProcessorDetails();
    m = Object.assign(m, proto);
    if (proto.csvFile) {
      m.csvFile = BulkProcessorDetailsCSVFile.fromProto(proto.csvFile);
    }
    if (proto.userList) {
      m.userList = BulkProcessorDetailsUserList.fromProto(proto.userList);
    }
    if (proto.importUsers) {
      m.importUsers = BulkProcessorDetailsImportUsers.fromProto(proto.importUsers);
    }
    if (proto.scheduleCampaign) {
      m.scheduleCampaign = BulkProcessorDetailsScheduleCampaign.fromProto(proto.scheduleCampaign);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.csvFile !== 'undefined' && this.csvFile !== null) {
      toReturn['csvFile'] = 'toApiJson' in this.csvFile ? this.csvFile.toApiJson() : this.csvFile;
    }
    if (typeof this.userList !== 'undefined' && this.userList !== null) {
      toReturn['userList'] = 'toApiJson' in this.userList ? this.userList.toApiJson() : this.userList;
    }
    if (typeof this.importUsers !== 'undefined' && this.importUsers !== null) {
      toReturn['importUsers'] = 'toApiJson' in this.importUsers ? this.importUsers.toApiJson() : this.importUsers;
    }
    if (typeof this.scheduleCampaign !== 'undefined' && this.scheduleCampaign !== null) {
      toReturn['scheduleCampaign'] = 'toApiJson' in this.scheduleCampaign ? this.scheduleCampaign.toApiJson() : this.scheduleCampaign;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsCSVFile {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsCSVFile();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsImportUsers {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsImportUsers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userListId !== 'undefined') {
      toReturn['userListId'] = this.userListId;
    }
    if (typeof this.updateUsers !== 'undefined') {
      toReturn['updateUsers'] = this.updateUsers;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsScheduleCampaign {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsScheduleCampaign();
    m = Object.assign(m, proto);
    if (proto.scheduleOn) {
      m.scheduleOn = new Date(proto.scheduleOn);
    }
    if (proto.sender) {
      m.sender = BulkProcessorDetailsScheduleCampaignSender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.campaignId !== 'undefined') {
      toReturn['campaignId'] = this.campaignId;
    }
    if (typeof this.scheduleOn !== 'undefined' && this.scheduleOn !== null) {
      toReturn['scheduleOn'] = 'toApiJson' in this.scheduleOn ? this.scheduleOn.toApiJson() : this.scheduleOn;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.defaultAccountGroupId !== 'undefined') {
      toReturn['defaultAccountGroupId'] = this.defaultAccountGroupId;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsScheduleCampaignSender {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsScheduleCampaignSender();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class BulkProcessorDetailsUserList {
  static fromProto(proto) {
    let m = new BulkProcessorDetailsUserList();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userListId !== 'undefined') {
      toReturn['userListId'] = this.userListId;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BulkProcessorType = /*#__PURE__*/function (BulkProcessorType) {
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_INVALID"] = 0] = "BULK_PROCESSOR_TYPE_INVALID";
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_IMPORT_USERS"] = 1] = "BULK_PROCESSOR_TYPE_IMPORT_USERS";
  BulkProcessorType[BulkProcessorType["BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN"] = 2] = "BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN";
  return BulkProcessorType;
}(BulkProcessorType || {});
// *********************************

function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActionListKey {
  static fromProto(proto) {
    let m = new ActionListKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class AddActionListItemsRequest {
  static fromProto(proto) {
    let m = new AddActionListItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class BulkActionInstanceStatus {
  static fromProto(proto) {
    let m = new BulkActionInstanceStatus();
    m = Object.assign(m, proto);
    if (proto.processedItems) {
      m.processedItems = parseInt(proto.processedItems, 10);
    }
    if (proto.totalItems) {
      m.totalItems = parseInt(proto.totalItems, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.processedItems !== 'undefined') {
      toReturn['processedItems'] = this.processedItems;
    }
    if (typeof this.totalItems !== 'undefined') {
      toReturn['totalItems'] = this.totalItems;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    if (typeof this.actionDisplayName !== 'undefined') {
      toReturn['actionDisplayName'] = this.actionDisplayName;
    }
    if (typeof this.isFinalized !== 'undefined') {
      toReturn['isFinalized'] = this.isFinalized;
    }
    return toReturn;
  }
}
class ComputeActionListIDsRequest {
  static fromProto(proto) {
    let m = new ComputeActionListIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.names !== 'undefined') {
      toReturn['names'] = this.names;
    }
    return toReturn;
  }
}
class ComputeActionListIDsResponse {
  static fromProto(proto) {
    let m = new ComputeActionListIDsResponse();
    m = Object.assign(m, proto);
    if (proto.nameIdMapping) {
      m.nameIdMapping = Object.keys(proto.nameIdMapping).reduce((obj, k) => {
        obj[k] = proto.nameIdMapping[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nameIdMapping !== 'undefined' && this.nameIdMapping !== null) {
      toReturn['nameIdMapping'] = 'toApiJson' in this.nameIdMapping ? this.nameIdMapping.toApiJson() : this.nameIdMapping;
    }
    return toReturn;
  }
}
class CreateActionListRequest {
  static fromProto(proto) {
    let m = new CreateActionListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class CreateActionListResponse {
  static fromProto(proto) {
    let m = new CreateActionListResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class DeleteActionListRequest {
  static fromProto(proto) {
    let m = new DeleteActionListRequest();
    m = Object.assign(m, proto);
    if (proto.actionListKey) {
      m.actionListKey = ActionListKey.fromProto(proto.actionListKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListKey !== 'undefined' && this.actionListKey !== null) {
      toReturn['actionListKey'] = 'toApiJson' in this.actionListKey ? this.actionListKey.toApiJson() : this.actionListKey;
    }
    return toReturn;
  }
}
class GenerateUploadSignedURLRequest {
  static fromProto(proto) {
    let m = new GenerateUploadSignedURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileName !== 'undefined') {
      toReturn['fileName'] = this.fileName;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    return toReturn;
  }
}
class GenerateUploadSignedURLResponse {
  static fromProto(proto) {
    let m = new GenerateUploadSignedURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.signedUrl !== 'undefined') {
      toReturn['signedUrl'] = this.signedUrl;
    }
    return toReturn;
  }
}
class GetActionListItemIDsRequest {
  static fromProto(proto) {
    let m = new GetActionListItemIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class GetActionListItemIDsResponse {
  static fromProto(proto) {
    let m = new GetActionListItemIDsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class GetBulkActionInstanceItemIDsRequest {
  static fromProto(proto) {
    let m = new GetBulkActionInstanceItemIDsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    return toReturn;
  }
}
class GetBulkActionInstanceItemIDsResponse {
  static fromProto(proto) {
    let m = new GetBulkActionInstanceItemIDsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bulkActionItemIds !== 'undefined') {
      toReturn['bulkActionItemIds'] = this.bulkActionItemIds;
    }
    return toReturn;
  }
}
class InitiateBulkActionRequest {
  static fromProto(proto) {
    let m = new InitiateBulkActionRequest();
    m = Object.assign(m, proto);
    if (proto.actionListKey) {
      m.actionListKey = ActionListKey.fromProto(proto.actionListKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListKey !== 'undefined' && this.actionListKey !== null) {
      toReturn['actionListKey'] = 'toApiJson' in this.actionListKey ? this.actionListKey.toApiJson() : this.actionListKey;
    }
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.hasFinalizeStep !== 'undefined') {
      toReturn['hasFinalizeStep'] = this.hasFinalizeStep;
    }
    return toReturn;
  }
}
class InitiateBulkProcessorRequest {
  static fromProto(proto) {
    let m = new InitiateBulkProcessorRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(BulkProcessorType, proto.type);
    }
    if (proto.details) {
      m.details = BulkProcessorDetails.fromProto(proto.details);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.details !== 'undefined' && this.details !== null) {
      toReturn['details'] = 'toApiJson' in this.details ? this.details.toApiJson() : this.details;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class InitiateBulkProcessorResponse {
  static fromProto(proto) {
    let m = new InitiateBulkProcessorResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ListBulkActionStatusesForActionListRequest {
  static fromProto(proto) {
    let m = new ListBulkActionStatusesForActionListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    return toReturn;
  }
}
class ListBulkActionStatusesForActionListResponse {
  static fromProto(proto) {
    let m = new ListBulkActionStatusesForActionListResponse();
    m = Object.assign(m, proto);
    if (proto.instances) {
      m.instances = proto.instances.map(BulkActionInstanceStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instances !== 'undefined' && this.instances !== null) {
      toReturn['instances'] = 'toApiJson' in this.instances ? this.instances.toApiJson() : this.instances;
    }
    return toReturn;
  }
}
class ComputeActionListIDsResponseNameIdMappingEntry {
  static fromProto(proto) {
    let m = new ComputeActionListIDsResponseNameIdMappingEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class RemoveActionListItemsRequest {
  static fromProto(proto) {
    let m = new RemoveActionListItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    return toReturn;
  }
}
class ValidateFileRequest {
  static fromProto(proto) {
    let m = new ValidateFileRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$2(BulkProcessorType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ValidateFileResponse {
  static fromProto(proto) {
    let m = new ValidateFileResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActionList {
  static fromProto(proto) {
    let m = new ActionList();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.legacyHistoryId !== 'undefined') {
      toReturn['legacyHistoryId'] = this.legacyHistoryId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkActionInstance {
  static fromProto(proto) {
    let m = new BulkActionInstance();
    m = Object.assign(m, proto);
    if (proto.initiated) {
      m.initiated = new Date(proto.initiated);
    }
    if (proto.completed) {
      m.completed = new Date(proto.completed);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.instanceId !== 'undefined') {
      toReturn['instanceId'] = this.instanceId;
    }
    if (typeof this.actionListId !== 'undefined') {
      toReturn['actionListId'] = this.actionListId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.itemIds !== 'undefined') {
      toReturn['itemIds'] = this.itemIds;
    }
    if (typeof this.error !== 'undefined') {
      toReturn['error'] = this.error;
    }
    if (typeof this.initiated !== 'undefined' && this.initiated !== null) {
      toReturn['initiated'] = 'toApiJson' in this.initiated ? this.initiated.toApiJson() : this.initiated;
    }
    if (typeof this.completed !== 'undefined' && this.completed !== null) {
      toReturn['completed'] = 'toApiJson' in this.completed ? this.completed.toApiJson() : this.completed;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'bulk-actions-api.vendasta-local.com',
  'test': '',
  'demo': 'bulk-actions-demo.apigateway.co',
  'prod': 'bulk-actions-prod.apigateway.co',
  'production': 'bulk-actions-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ActionListsApiService = /*#__PURE__*/(() => {
  class ActionListsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createActionList(r) {
      const request = r.toApiJson ? r : new CreateActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/CreateActionList", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateActionListResponse.fromProto(resp)));
    }
    deleteActionList(r) {
      const request = r.toApiJson ? r : new DeleteActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/DeleteActionList", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addActionListItems(r) {
      const request = r.toApiJson ? r : new AddActionListItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/AddActionListItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    removeActionListItems(r) {
      const request = r.toApiJson ? r : new RemoveActionListItemsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/RemoveActionListItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getActionListItemIDs(r) {
      const request = r.toApiJson ? r : new GetActionListItemIDsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/GetActionListItemIDs", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetActionListItemIDsResponse.fromProto(resp)));
    }
    computeActionListId(r) {
      const request = r.toApiJson ? r : new ComputeActionListIDsRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.ActionLists/ComputeActionListID", request.toApiJson(), this.apiOptions()).pipe(map(resp => ComputeActionListIDsResponse.fromProto(resp)));
    }
  }
  ActionListsApiService.ɵfac = function ActionListsApiService_Factory(t) {
    return new (t || ActionListsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ActionListsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsApiService,
    factory: ActionListsApiService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ActionListsSdkService = /*#__PURE__*/(() => {
  class ActionListsSdkService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    getItemIDs(partnerId, marketId, actionListId) {
      return this.delegate.getActionListItemIDs({
        partnerId: partnerId,
        marketId: marketId,
        actionListId: actionListId
      }).pipe(map(resp => resp.itemIds));
    }
  }
  ActionListsSdkService.ɵfac = function ActionListsSdkService_Factory(t) {
    return new (t || ActionListsSdkService)(i0.ɵɵinject(ActionListsApiService));
  };
  ActionListsSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ActionListsSdkService,
    factory: ActionListsSdkService.ɵfac,
    providedIn: 'root'
  });
  return ActionListsSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BulkProcessorApiService = /*#__PURE__*/(() => {
  class BulkProcessorApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    generateUploadSignedUrl(r) {
      const request = r.toApiJson ? r : new GenerateUploadSignedURLRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/GenerateUploadSignedURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GenerateUploadSignedURLResponse.fromProto(resp)));
    }
    initiateBulkProcessor(r) {
      const request = r.toApiJson ? r : new InitiateBulkProcessorRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/InitiateBulkProcessor", request.toApiJson(), this.apiOptions()).pipe(map(resp => InitiateBulkProcessorResponse.fromProto(resp)));
    }
    validateFile(r) {
      const request = r.toApiJson ? r : new ValidateFileRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkProcessor/ValidateFile", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateFileResponse.fromProto(resp)));
    }
  }
  BulkProcessorApiService.ɵfac = function BulkProcessorApiService_Factory(t) {
    return new (t || BulkProcessorApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BulkProcessorApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkProcessorApiService,
    factory: BulkProcessorApiService.ɵfac,
    providedIn: 'root'
  });
  return BulkProcessorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BulkProcessorSdkService = /*#__PURE__*/(() => {
  class BulkProcessorSdkService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    generateUploadSignedUrl(fileName, contentType) {
      return this.delegate.generateUploadSignedUrl({
        fileName,
        contentType
      }).pipe(map(resp => resp.signedUrl));
    }
    initiateImportUsers(partnerId, fileUrl, userListId, updateUsers) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_IMPORT_USERS,
        partnerId: partnerId,
        details: {
          csvFile: {
            fileUrl: fileUrl
          },
          importUsers: {
            userListId: userListId,
            updateUsers: updateUsers
          }
        }
      };
      return this.delegate.initiateBulkProcessor(req).pipe(map(resp => resp.id));
    }
    scheduleCampaign(partnerId, userListId, campaignId, scheduleOn, defaultAccountGroupId, email, name) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_SCHEDULE_CAMPAIGN,
        partnerId: partnerId,
        details: {
          userList: {
            userListId: userListId
          },
          scheduleCampaign: {
            campaignId: campaignId,
            scheduleOn: scheduleOn,
            defaultAccountGroupId: defaultAccountGroupId,
            sender: {
              email: email,
              name: name
            }
          }
        }
      };
      return this.delegate.initiateBulkProcessor(req).pipe(map(resp => resp.id));
    }
    validateImportUserFile(fileUrl, partnerId) {
      const req = {
        type: BulkProcessorType.BULK_PROCESSOR_TYPE_IMPORT_USERS,
        fileUrl: fileUrl,
        partnerId: partnerId
      };
      return this.delegate.validateFile(req).pipe(map(res => res.errors || []));
    }
  }
  BulkProcessorSdkService.ɵfac = function BulkProcessorSdkService_Factory(t) {
    return new (t || BulkProcessorSdkService)(i0.ɵɵinject(BulkProcessorApiService));
  };
  BulkProcessorSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkProcessorSdkService,
    factory: BulkProcessorSdkService.ɵfac,
    providedIn: 'root'
  });
  return BulkProcessorSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let BulkActionStatusApiService = /*#__PURE__*/(() => {
  class BulkActionStatusApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listBulkActionStatusesForActionList(r) {
      const request = r.toApiJson ? r : new ListBulkActionStatusesForActionListRequest(r);
      return this.http.post(this._host + "/bulk_actions.v1beta1.BulkActionStatus/ListBulkActionStatusesForActionList", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListBulkActionStatusesForActionListResponse.fromProto(resp)));
    }
  }
  BulkActionStatusApiService.ɵfac = function BulkActionStatusApiService_Factory(t) {
    return new (t || BulkActionStatusApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  BulkActionStatusApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkActionStatusApiService,
    factory: BulkActionStatusApiService.ɵfac,
    providedIn: 'root'
  });
  return BulkActionStatusApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BulkActionsSdkStatusService = /*#__PURE__*/(() => {
  class BulkActionsSdkStatusService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    list(partnerId, marketId, actionListId) {
      const req = new ListBulkActionStatusesForActionListRequest({
        partnerId: partnerId,
        marketId: marketId,
        actionListId: actionListId
      });
      return this.delegate.listBulkActionStatusesForActionList(req).pipe(map(r => fillMissingValues(r.instances)));
    }
  }
  BulkActionsSdkStatusService.ɵfac = function BulkActionsSdkStatusService_Factory(t) {
    return new (t || BulkActionsSdkStatusService)(i0.ɵɵinject(BulkActionStatusApiService));
  };
  BulkActionsSdkStatusService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BulkActionsSdkStatusService,
    factory: BulkActionsSdkStatusService.ɵfac,
    providedIn: 'root'
  });
  return BulkActionsSdkStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function fillMissingValues(resp) {
  return resp.map(v => {
    v.processedItems = v.processedItems || 0;
    v.totalItems = v.totalItems || 0;
    return v;
  });
}

/**
 * Generated bundle index. Do not edit.
 */

export { ActionListsSdkService, BulkActionsSdkStatusService, BulkProcessorSdkService, ListBulkActionStatusesForActionListRequest };
